export const ProductTypes = {
  SUPPLIER_PRODUCT: 1, // 'Supplier Product'
  CUSTOM_PRODUCT: 2, // 'Custom Product'
  PACK_TEMPLATE: 3, // 'Pack Template'
  CUSTOM_PACK: 4, // 'Custom Pack'
  CUSTOM_PACK_TEMPLATE: 5, // 'Custom Pack Template'
} as const;

export const DesignStatusId = {
  PENDING_DESIGN: 1, // 'Pending Design'
  DESIGN_READY: 2, // 'Design Ready'
  CHANGES_REQUESTED: 3, // 'Changes Requested'
  APPROVED: 4, // 'Approved'
} as const;

export const DesignStatus = {
  PENDING_DESIGN: 'Pending Design',
  DESIGN_READY: 'Design Ready',
  CHANGES_REQUESTED: 'Changes Requested',
  APPROVED: 'Approved',
} as const;

export const ConfigurationTypes = {
  decorated: 'Decorated',
  blank: 'Blank',
  sample: 'Sample',
} as const;

export const baseImgUrl = 'https://swagcharm-static.s3.amazonaws.com/';

export const OrderStatusId = {
  PENDING: 1, // 'Pending production'
  IN_PRODUCTION: 2, // 'In production'
  COMPLETE: 3, // 'Complete'
  CANCELED: 4, // 'Canceled'
} as const;

export const OrderStatus = {
  PENDING: 'Pending',
  IN_PRODUCTION: 'In production',
  COMPLETE: 'Complete',
} as const;

export const OrderStatusMap = {
  [OrderStatusId.PENDING]: OrderStatus.PENDING,
  [OrderStatusId.IN_PRODUCTION]: OrderStatus.IN_PRODUCTION,
  [OrderStatusId.COMPLETE]: OrderStatus.COMPLETE,
  [OrderStatusId.CANCELED]: 'Canceled',
} as const;

export const OrderTypeId = {
  DRAFT: 1, // 'Draft',
  SUBMITTED: 2, // 'Submitted',
} as const;

export const OrderType = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
} as const;

export const OrderStorageType = {
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
} as const;

export const PaymentStatusId = {
  PENDING_PAYMENT: 'pending_payment',
  PROCESSING_PAYMENT: 'processing_payment',
  PAID: 'paid',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_CANCELED: 'payment_canceled',
  PAYMENT_REFUNDED: 'payment_refunded'
} as const;

export const PaymentStatus = {
  PENDING_PAYMENT: 'Pending Payment',
  PROCESSING_PAYMENT: 'Processing Payment',
  PAID: 'Paid',
  PAYMENT_FAILED: 'Payment Failed',
  PAYMENT_CANCELED: 'Payment Canceled',
  PAYMENT_REFUNDED: 'Refunded'
} as const;

export const PaymentStatusMap = {
  [PaymentStatusId.PENDING_PAYMENT]: PaymentStatus.PENDING_PAYMENT,
  [PaymentStatusId.PROCESSING_PAYMENT]: PaymentStatus.PROCESSING_PAYMENT,
  [PaymentStatusId.PAID]: PaymentStatus.PAID,
  [PaymentStatusId.PAYMENT_FAILED]: PaymentStatus.PAYMENT_FAILED,
  [PaymentStatusId.PAYMENT_CANCELED]: PaymentStatus.PAYMENT_CANCELED,
  [PaymentStatusId.PAYMENT_REFUNDED]: PaymentStatus.PAYMENT_REFUNDED,
} as const;

export const AttributesKeys = {
  colors: 'color',
  sizes: 'size',
  book_types: 'book_type',
} as const;

export const ShipmentStatusId = {
  CREATED: 1, // 'Created'
  IN_TRANSIT: 2, // 'In transit'
  DELIVERED: 3, // 'Delivered'
  CANCELED: 4, // 'Canceled'
} as const;

export const ShipmentStatus = {
  CREATED: 'Created',
  IN_TRANSIT: 'In transit',
  DELIVERED: 'Delivered',
} as const;

export const ShipmentStatusMap = {
  [ShipmentStatusId.CREATED]: ShipmentStatus.CREATED,
  [ShipmentStatusId.IN_TRANSIT]: ShipmentStatus.IN_TRANSIT,
  [ShipmentStatusId.DELIVERED]: ShipmentStatus.DELIVERED,
  [ShipmentStatusId.CANCELED]: 'Canceled',
} as const;

export const CartItemType = {
  product: 'Product',
  pack: 'Pack',
} as const;

export const IntegrationStatusColors = {
  Connected: '#4CAF50',
  Incomplete: '#ED6C02',
  'Relink Needed': '#ED6C02',
} as const;

export const DevAppIntegrationType = {
  PRIVATE: 'PRIVATE',
  THIRD_PARTY: 'THIRD_PARTY',
} as const;

export const DevAppIntegrationTypeValue = {
  PRIVATE: 'Private',
  THIRD_PARTY: 'Third Party',
} as const;

export const MediaContentType = {
  IMAGE: 1,
  VIDEO: 2,
  PDF: 3,
  OTHER: 4,
} as const;

export const LocationImageType = {
  FRONT: 1007,
  REAR: 1008,
  SHORT_LEFT_SLEEVE: 501,
  SHORT_RIGHT_SLEEVE: 502,
  LONG_LEFT_SLEEVE: 503,
  LONG_RIGHT_SLEEVE: 504,

  TRANSPARENT: 510,
  UNSPECIFIED: 1000,
  BLANK: 1001,
  DECORATED: 1002,
  ALTERNATE: 1003,
  SWATCH: 1004,
  CUSTOM: 1005,
  PRIMARY: 1006,
  RIGHT: 1009,
  LEFT: 1010,
  TOP: 1011,
  BOTTOM: 1012,
  INSIDE: 1013,
  OUTSIDE: 1014,
  STANDARD: 2000,
  HIGH: 2001,
  PODCAST: 3000,
  SPECS: 4000,
  PRODUCTSAFETY: 4001,
  FACTS: 4002,
  COMPLIANCE: 4003,
  ARTTEMPLATE: 4004,
  MARKETING: 4005,
} as const;
